import Request from '../Request.utils'
export interface IGetCompanyAblStateRequestParams {
  companyId: string;
}
export interface IGetCompanyAblStateRequestQuery {
  locationId?: string;
}
export interface IGetCompanyAblOverviewRequestParams {
  companyId: string;
}
export interface IGetCompanyAblOverviewRequestQuery {
  budgetCategory?: string;
  search?: string;
}
export interface IUpsertMasterAblRequestBody {
  label?: string;
  products: {
    budgetCategory: string;
    productId: string;
  }[];
}
export interface IUpsertMasterAblRequestParams {
  companyId: string;
}
export interface IImportMasterAblByVariantRowsRequestBody {
  label?: string;
  rows: {
    budgetCategory: string;
    sku: string;
  }[];
}
export interface IImportMasterAblByVariantRowsRequestParams {
  companyId: string;
}
export interface IImportLocationAblByVariantRowsRequestBody {
  label?: string;
  rows: {
    budgetCategory: string;
    locationId: string;
    sku: string;
  }[];
}
export interface IImportLocationAblByVariantRowsRequestParams {
  companyId: string;
}
export interface ICopyMasterToLocationRequestParams {
  companyId: string;
  locationId: string;
}
export interface IUpsertLocationAblRequestBody {
  add?: {
    budgetCategory: string;
    productId: string;
  }[];
  label?: string;
  remove?: string[];
}
export interface IUpsertLocationAblRequestParams {
  companyId: string;
  locationId: string;
}
export interface IListAblVersionsRequestParams {
  companyId: string;
}
export interface ICreateManualAblSnapshotRequestBody {
  label?: string;
  summary?: string;
}
export interface ICreateManualAblSnapshotRequestParams {
  companyId: string;
}
export interface IRollbackAblVersionRequestBody {
  versionId: string;
}
export interface IRollbackAblVersionRequestParams {
  companyId: string;
}
export interface ISyncLocationAblToShopifyRequestBody {
  force?: boolean;
}
export interface ISyncLocationAblToShopifyRequestParams {
  companyId: string;
  locationId: string;
}
export interface ISyncLocationAblToShopifyRequestQuery {
  force?: boolean;
}
export interface IGetCompanyLocationBudgetsRequestParams {
  companyId: string;
}
export interface ISaveCompanyLocationBudgetsRequestBody {
  locations: ({
    budget: {
      /**
       * Unknown Property
       */
      [x: string]: unknown;
      allocations: {
        consumables: number;
        machinery: number;
        materials: number;
        miscellaneous: number;
        workwear: number;
      };
      budgetStartDate?: string | null | '';
      enabled: boolean;
      rolloverEnabled?: boolean;
      rolloverFrequency?: 'weekly' | 'monthly' | null;
      rolloverPeriods?: number;
    };
    shopifyId: string;
  })[];
}
export interface ISaveCompanyLocationBudgetsRequestParams {
  companyId: string;
}


class AblAPI {
  getCompanyAblState = async (params: IGetCompanyAblStateRequestParams, query: IGetCompanyAblStateRequestQuery) => {
    const res = await Request.call('/api/abl/:companyId/state', 'GET', params, query, undefined, );
    return res;
  }
  getCompanyAblOverview = async (params: IGetCompanyAblOverviewRequestParams, query: IGetCompanyAblOverviewRequestQuery) => {
    const res = await Request.call('/api/abl/:companyId/overview', 'GET', params, query, undefined, );
    return res;
  }
  upsertMasterAbl = async (params: IUpsertMasterAblRequestParams, body: IUpsertMasterAblRequestBody) => {
    const res = await Request.call('/api/abl/:companyId/master', 'POST', params, undefined, body, );
    return res;
  }
  importMasterAblByVariantRows = async (params: IImportMasterAblByVariantRowsRequestParams, body: IImportMasterAblByVariantRowsRequestBody) => {
    const res = await Request.call('/api/abl/:companyId/master/import-variant-rows', 'POST', params, undefined, body, );
    return res;
  }
  importLocationAblByVariantRows = async (params: IImportLocationAblByVariantRowsRequestParams, body: IImportLocationAblByVariantRowsRequestBody) => {
    const res = await Request.call('/api/abl/:companyId/locations/import-variant-rows', 'POST', params, undefined, body, );
    return res;
  }
  copyMasterToLocation = async (params: ICopyMasterToLocationRequestParams) => {
    const res = await Request.call('/api/abl/:companyId/locations/:locationId/copy-master', 'POST', params, undefined, undefined, );
    return res;
  }
  upsertLocationAbl = async (params: IUpsertLocationAblRequestParams, body: IUpsertLocationAblRequestBody) => {
    const res = await Request.call('/api/abl/:companyId/locations/:locationId/abl', 'POST', params, undefined, body, );
    return res;
  }
  listAblVersions = async (params: IListAblVersionsRequestParams) => {
    const res = await Request.call('/api/abl/:companyId/versions', 'GET', params, undefined, undefined, );
    return res;
  }
  createManualAblSnapshot = async (params: ICreateManualAblSnapshotRequestParams, body: ICreateManualAblSnapshotRequestBody) => {
    const res = await Request.call('/api/abl/:companyId/snapshot', 'POST', params, undefined, body, );
    return res;
  }
  rollbackAblVersion = async (params: IRollbackAblVersionRequestParams, body: IRollbackAblVersionRequestBody) => {
    const res = await Request.call('/api/abl/:companyId/rollback', 'POST', params, undefined, body, );
    return res;
  }
  syncLocationAblToShopify = async (params: ISyncLocationAblToShopifyRequestParams, query: ISyncLocationAblToShopifyRequestQuery, body: ISyncLocationAblToShopifyRequestBody) => {
    const res = await Request.call('/api/abl/:companyId/locations/:locationId/sync-shopify', 'POST', params, query, body, );
    return res;
  }
  getCompanyLocationBudgets = async (params: IGetCompanyLocationBudgetsRequestParams) => {
    const res = await Request.call('/api/abl/:companyId/location-budgets', 'GET', params, undefined, undefined, );
    return res;
  }
  saveCompanyLocationBudgets = async (params: ISaveCompanyLocationBudgetsRequestParams, body: ISaveCompanyLocationBudgetsRequestBody) => {
    const res = await Request.call('/api/abl/:companyId/location-budgets', 'POST', params, undefined, body, );
    return res;
  }
}
export default new AblAPI()